import { render, staticRenderFns } from "./PrepareVerification.vue?vue&type=template&id=20a291d8&"
import script from "./PrepareVerification.vue?vue&type=script&lang=ts&"
export * from "./PrepareVerification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports